import { render, staticRenderFns } from "./FullPageLoader.vue?vue&type=template&id=0cb55392&scoped=true&"
var script = {}
import style0 from "./FullPageLoader.vue?vue&type=style&index=0&id=0cb55392&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb55392",
  null
  
)

export default component.exports